import { Dialogs } from '@leverege/ui-elements';
import { AllowedReducer, Constants } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
// import { Context } from '@leverege/plugin'
import CancelTransferView from "./CancelTransferView.js";
const ACTION = 'cancelTransfer';
export default {
  id: 'actions.cancelTransfer',
  name: 'Cancel Transfer',
  layout: {
    sort: 'z'
  },
  matches: [{
    use: ['contextMenu'],
    path: ['organization.companies.locations.parentTransfers', 'company.locations.parentTransfers', 'location.parentTransfers', 'parentTransfer']
  }],
  isPrepared: context => {
    const {
      target: targets
    } = context;
    if (targets.length === 0) return true;
    const target = targets[0];
    const transferId = target.id;
    const a = AllowedReducer.get(GlobalState.get(), transferId);
    return a[ACTION] != null;
  },
  prepare: async context => {
    const {
      target: targets
    } = context;
    const params = context.clientProps.match.params;
    const target = targets[0];
    const transferId = target.id;
    const transfer = GlobalState.get()?.models?.lookup?.[transferId];
    const systemId = transfer.systemId;
    const orgId = params.organizationId;
    const companyId = params.companyId;
    const locationId = params.locationId;
    return GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      let res;
      if (orgId) {
        res = await api.interface(systemId, 'organization').obj(orgId).grp('companies').obj(companyId).grp('locations').obj(locationId).grp('parentTransfers').obj(transferId).srv('ownershipTransfer').post('cancelBulkTransfer', null, {
          test: true
        });
      } else {
        res = await api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId).grp('parentTransfers').obj(transferId).srv('ownershipTransfer').post('cancelBulkTransfer', null, {
          test: true
        });
      }
      dispatch({
        type: Constants.ALLOWED_SET,
        resourceId: transferId,
        action: ACTION,
        allowed: res.allowed === true
      });
      return res.allowed === true;
    });
  },
  handles: context => {
    const {
      target: targets
    } = context;
    if (targets.length !== 1) {
      return false;
    }
    const transfer = GlobalState.get()?.models?.lookup?.[targets[0].id];

    // only handle incoming pending transfers
    if (transfer.data?.status !== 'pending' || transfer.data?.type !== 'outgoing') {
      return false;
    }
    const transferId = targets[0]?.id;
    const a = AllowedReducer.get(GlobalState.get(), transferId);
    return a[ACTION] === true;
  },
  appearance: ({
    context,
    action
  }) => {
    return {
      name: 'Cancel Transfer',
      icon: 'fa fa-xmark'
    };
  },
  perform: ({
    context
  }) => {
    const {
      target: targets,
      reloadData
    } = context;
    const organizationId = context.clientProps?.match?.params?.organizationId;
    const parentOutgoingTransfer = GlobalState.get()?.models?.lookup?.[targets[0].id];
    Dialogs.show({
      component: CancelTransferView,
      props: {
        parentOutgoingTransfer,
        reloadData,
        organizationId
      }
    });
  }
};